import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/eLabel/importer/eLabelImporterActions';

export default importerReducers(actions);
